import client from 'app/client';

export interface MyAvailableTunnelsResponse {
  tunnelIds: string[];
}

/**
 * Retourne les tunnelIds que l'utilisateur courant (courtier) peut utiliser pour
 * créer ses propres contrats / devis dans son OU active.
 * Basé sur la table CourtierTunnelHabilitation.
 */
export async function getMyTunnelsAvailableForCreation(): Promise<MyAvailableTunnelsResponse> {
  const { data } = await client.get<MyAvailableTunnelsResponse>(
    '/backoffice/tunnels/me/available-for-creation',
  );
  return data;
}

/**
 * Retourne les tunnelIds que l'utilisateur courant peut utiliser pour vendre :
 * ses propres contrats + contrats orga où il est autorisé via CourtierContratDeGroupe.
 */
export async function getMyTunnelsAvailableForSelling(): Promise<MyAvailableTunnelsResponse> {
  const { data } = await client.get<MyAvailableTunnelsResponse>(
    '/backoffice/tunnels/me/available-for-selling',
  );
  return data;
}
